import React from 'react';
import BadgeIcon from './BadgeIcon';

function ChatBadges({ roleBadge, clubBadge, legacyBadge, className = '' }) {
  const effectiveRole = roleBadge || legacyBadge;
  const hasRole = !!(effectiveRole?.url || effectiveRole?.svg);
  const hasClub = !!(clubBadge?.url || clubBadge?.svg);
  if (!hasRole && !hasClub) return null;
  return (
    <span className={['chat-badges', className].filter(Boolean).join(' ')}>
      {hasRole && <BadgeIcon badge={effectiveRole} />}
      {hasClub && <BadgeIcon badge={clubBadge} />}
    </span>
  );
}

export default ChatBadges;